import React from "react";

export default function WorkingHours() {
  return (
    <div
      style={{
        background: "#fff",
        // marginTop: 15,
        padding: 12,
        borderRadius: "5px",
        border: "1px solid #e5e7eb",
      }}
    >
      {/* TOP STATS */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 15,
        }}
      >
        {[
          { label: "Total Working hours", value: "12h 36m", color: "#9ca3af" },
          { label: "Productive Hours", value: "08h 36m", color: "#22c55e" },
          { label: "Break hours", value: "22m 15s", color: "#f59e0b" },
          { label: "Overtime", value: "02h 15m", color: "#2563eb" },
        ].map((item, i) => (
          <div key={i} style={{ minWidth: 150 }}>
            <p
              style={{
                margin: 0,
                fontSize: 14,
                color: "#6b7280",
                display: "flex",
                alignItems: "center",
                gap: 6,
              }}
            >
              <span
                style={{
                  width: 7,
                  height: 7,
                  borderRadius: "50%",
                  background: item.color,
                  display: "inline-block",
                }}
              ></span>
              {item.label}
            </p>

            <h4 style={{ margin: "5px 0", fontWeight: 700 }}>
              {item.value}
            </h4>
          </div>
        ))}
      </div>

      {/* TIMELINE BAR */}
      <div
        style={{
          marginTop:14,
          padding: "12px 10px",
          background: "#f9fafb",
          borderRadius: 10,
        }}
      >
        <div style={{ display: "flex", gap: 6 }}>
          {/* GREEN BLOCK */}
          <div style={{
            width: "20%",
            height: 24,
            background: "#22c55e",
            borderRadius: 6
          }} />

          {/* BREAK */}
          <div style={{
            width: "5%",
            height:24,
            background: "#f59e0b",
            borderRadius: 6
          }} />

          {/* GREEN */}
          <div style={{
            width: "25%",
            height: 24,
            background: "#22c55e",
            borderRadius: 6
          }} />

          {/* BREAK */}
          <div style={{
            width: "15%",
            height: 24,
            background: "#f59e0b",
            borderRadius: 6
          }} />

          {/* GREEN */}
          <div style={{
            width: "20%",
            height: 24,
            background: "#22c55e",
            borderRadius: 6
          }} />

          {/* BREAK */}
          <div style={{
            width: "5%",
            height: 24,
            background: "#f59e0b",
            borderRadius: 6
          }} />

          {/* OVERTIME */}
          <div style={{
            width: "3%",
            height: 24,
            background: "#2563eb",
            borderRadius: 6
          }} />

          <div style={{
            width: "2%",
            height: 26,
            background: "#2563eb",
            borderRadius: 6
          }} />
        </div>

        {/* TIME SCALE */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop:9,
            fontSize: 12,
            color: "#6b7280",
            flexWrap: "wrap",
          }}
        >
          {[
            "06:00","07:00","08:00","09:00","10:00","11:00",
            "12:00","01:00","02:00","03:00","04:00","05:00",
            "06:00","07:00","08:00","09:00","10:00","11:00"
          ].map((t, i) => (
            <span key={i}>{t}</span>
          ))}
        </div>
      </div>

      {/* RESPONSIVE FIX */}
      <style>
        {`
          @media (max-width: 1024px) {
            div[style] {
              margin-top: 15px !important;
            }
          }
        `}
      </style>
    </div>
  );
}